import GestionHero from "../components/gestion/GestionHero";
import Wall from "../components/gestion/Wall";
import Model from "../components/gestion/Model";
import Services from "../components/gestion/Services";
import HowItWorks from "../components/home/HowItWorks";
import GestionFinalCta from "../components/gestion/GestionFinalCta";

export default function Gestion() {
  return (
    <main data-testid="gestion-page">
      <GestionHero />
      <Wall />
      <Model />
      <Services />
      <HowItWorks />
      <GestionFinalCta />
    </main>
  );
}
